module.exports = __webpack_public_path__ + "static/media/price_svg.a1ad72f9.svg";